<div class="container d-flex justify-content-center">
  <form class="card w-50 m-5" [formGroup]="userform" (ngSubmit)="onSubmit()">
    <img class="card-img-top my-4 px-4" src="assets/img/logo.png" />
    <div class="card-body">
      <div class="input-group mb-3">
        <label for="username-input" class="input-group-text"><fa-icon [icon]="['fas','user']"></fa-icon></label>
        <input
          formControlName="username"
          aria-label="Username"
          type="text"
          placeholder="Username"
          class="form-control"
          id="username-input"
          required
        />
      </div>
      <div class="input-group mb-3">
        <label for="password-input" class="input-group-text"><fa-icon [icon]="['fas','lock']"></fa-icon></label>
        <input formControlName="password" type="password" placeholder="Password" class="form-control" id="password-input" required />
      </div>
      <div class="d-flex justify-content-center mt-3">
        <button type="submit" class="btn btn-primary" [disabled]="!userform.valid || loading" style="padding: 0.5em 4em">Login</button>
      </div>
    </div>
  </form>
</div>
